import React from "react"
import PropTypes from "prop-types"
import { Button, Flex } from "antd"
import { Icon } from "ui/Icon"
import styles from "./BookingPanel.module.css"

// "−  4  +" stepper of the booking panel. The buttons are disabled at the limits the parent passes.
const Counter = ({ value, decreaseLabel, increaseLabel, isDecreaseDisabled, isIncreaseDisabled, onChange }) => (
  <Flex align="center" gap={12}>
    <Button
      shape="circle"
      className={styles.counterButton}
      aria-label={decreaseLabel}
      disabled={isDecreaseDisabled}
      onClick={() => onChange(value - 1)}
      icon={<Icon type="feather" name="Minus" width={16} height={16} color="currentColor" />}
    />
    <span className={styles.counterValue} aria-live="polite">
      {value}
    </span>
    <Button
      shape="circle"
      className={styles.counterButton}
      aria-label={increaseLabel}
      disabled={isIncreaseDisabled}
      onClick={() => onChange(value + 1)}
      icon={<Icon type="feather" name="Plus" width={16} height={16} color="currentColor" />}
    />
  </Flex>
)

Counter.propTypes = {
  value: PropTypes.number.isRequired,
  decreaseLabel: PropTypes.string.isRequired,
  increaseLabel: PropTypes.string.isRequired,
  isDecreaseDisabled: PropTypes.bool,
  isIncreaseDisabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired
}

Counter.defaultProps = {
  isDecreaseDisabled: false,
  isIncreaseDisabled: false
}

export default Counter
